<template>
  <div class="row pos-table-row">
    <div class="col-7">
      <div class="pos-product-thumb">
        <img class="img" v-lazy="{
          src: productPhoto(item),
          error: require('@/assets/default-product.jpg'),
          loading: require('@/assets/Rolling-1s-200px_2.svg')
        }" />
        <div class="info">
          <div class="title">
            {{
              item.product_name_kh ? item.product_name_kh : item.product_name_en
            }}
          </div>
          <div class="desc">
            - {{ $t('restaurantSale.size') }}: {{ item.uom_name_en }} -
            {{ $t('restaurantSale.price') }}:
            {{ defaultCrrency }}
            {{ item.unit_price | format_number }}
          </div>
          <div class="desc">
            - {{ $t('restaurantSale.discount') }}
            {{ item.discount_rate ? '(' + item.discount_rate + item.discount_type + ')' : '' }}:
            {{ defaultCrrency }}
            {{ item.discount_amount | format_number }}
          </div>
          <div class="desc text-info">
            {{ item.ref_table_no ? '- ' + $t('restaurantSale.orderBy') + ' : ' + item.ref_table_no : '' }}
          </div>
          <span v-if="item.service_length" class="badge ts-font-semibold ts-ml-2" :class="badgeClass(item)"
            @click="onShowService">
            <span v-if="!item.start_time">Start</span>
            <span v-else>
              {{ startTime(item) }} ~ {{ endTime(item) }}
            </span>
          </span>
        </div>
      </div>
    </div>
    <div class="col-2 total-qty">
      x{{ item.quantity }}
      <br />
      <small class="desc" :class="cookingStatusClass(item.cooking_status_id)"><i class="fas fa-mortar-pestle"></i> {{
        item.cooking_status }}</small>
    </div>
    <div class="col-3 total-price">
      <div v-if="item.is_pre_charge">{{ defaultCrrency }}
        {{ item.total_after_discount | format_number }}
        <br />
        <span class="text-success">Paid</span>
      </div>
      <div v-else>
        {{ defaultCrrency }}
        {{ item.total_after_discount | format_number }}
        <br />
        <a-popconfirm v-if="item.cooking_status_id == 1 && !lock" placement="leftTop"
          :title="$t('are_you_sure_to_delete')" :ok-text="$t('yes')" :cancel-text="$t('no')"
          @confirm="$emit('removeItem')">
          <a href="#" class="btn btn-danger btn-xs">
            <i class="fa fa-trash"></i>
          </a>
        </a-popconfirm>
      </div>
    </div>
    <modal :name="'modalServiceLength' + item.product_id + item.ref_table_id" height="auto" width="450px"
      :scrollable="true" draggable=".form-header" :clickToClose="false">
      <div class="ts-p-6">
        <label
          class="col-form-label ts-mb-3 ts-font-bold ts-w-full ts-px-2 bg-success ts-flex ts-justify-items-center ts-items-center"
          style="height: 45px;">
          <i class="fa fa-id-card fa-fw fa-lg ts-pb-1" style="color: white;"></i>
          <h4 style="margin: 0 !important;color: white;" class="ts-pl-2">{{ $t('restaurantSale.serviceDuration') }}</h4>
        </label>
        <div class="ts-border-t ts-border-gray-300">
          <div class="ts-my-3">
            <div class="pos pos-counter">
              <div class="pos-counter-body">
                <div class="pos-counter-content">
                  <div class="card-info">
                    <div class="info-item">
                      <div class="info-label">{{ $t('restaurantSale.product') }}</div>
                      <div class="info-value">{{ item.product_name_en }}</div>
                    </div>
                    <div class="info-item">
                      <div class="info-label">{{ $t('restaurantSale.serviceLength') }}</div>
                      <div class="info-value">{{ item.service_length }} mn</div>
                    </div>
                    <div class="info-item">
                      <div class="info-label">{{ $t('restaurantSale.price') }}</div>
                      <div class="info-value">{{ defaultCrrency }} {{ item.grand_total }}</div>
                    </div>
                    <div class="info-item">
                      <div class="info-label">{{ $t('restaurantSale.startEndService') }}</div>
                      <div v-if="item.service_length" class="info-value">
                        {{ startTime(item) }} - {{ endTime(item) }}
                      </div>
                      <div v-else class="info-value">N/A</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="btn-row ts-space-x-2 ts-text-right ts-border-t ts-border-gray-300 ts-pt-4">
            <ts-button @click.prevent="onHideService()"><i class="fa fa-arrow-left fa-fw fa-lg"></i>
              {{ $t('restaurantSale.back') }}</ts-button>
            <ts-button v-if="!item.start_time" class="btn-success" @click.prevent="onStartTime(false)"><i
                class="fa fa-play fa-fw fa-lg"></i>
              {{ $t('restaurantSale.startTime') }}</ts-button>
            <ts-button v-else class="btn-warning" @click.prevent="onEndTime()"><i class="fa fa-pause fa-fw fa-lg"></i>
              {{ $t('restaurantSale.endTime') }}</ts-button>
          </div>
        </div>
        <Spin size="large" fix v-if="loading"></Spin>
      </div>
    </modal>
  </div>
</template>

<script>
import moment from 'moment';
import Swal from 'sweetalert2'

export default {
  name: 'OrderItem',
  props: {
    item: {
      type: Object,
      required: true
    },
    defaultCrrency: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      loading: false,
    }
  },
  filters: {
    format_number(value) {
      if (value) {
        return `${parseFloat(value).toLocaleString()}`
      }
      return 0
    }
  },
  computed: {
    lock: {
      get() {
        return this.$store.state.restaurantSale.counterCheckout.lock
      },
      set(newValue) {
        this.$store.commit('restaurantSale/counterCheckout/SET_LOCK', newValue)
      }
    },
  },
  methods: {
    fetchTables(attributes) {
      this.$emit('fetchTableByInterval', attributes);
      // this.$store
      //   .dispatch('restaurantSale/counterCheckout/fetchTables', attributes)
      //   .catch(error => {
      //     this.$notification['error']({
      //       message: 'FETCH TABLE',
      //       description: error.message,
      //       placement: 'bottomRight'
      //     })
      //   })
    },
    onShowService() {
      if (this.item.start_time && this.item.end_time) {
        return
      }
      this.$modal.show('modalServiceLength' + this.item.product_id + this.item.ref_table_id)
    },
    onHideService() {
      this.$modal.hide('modalServiceLength' + this.item.product_id + this.item.ref_table_id)
    },
    onConfrim(response) {
      Swal.fire({
        icon: 'warning',
        html: '<b>' + response.message + '</b><br />' +
          (response.next_locker_message ? response.next_locker_message : ''),
        showCancelButton: true,
        showConfirmButton: true,
        confirmButtonText: "Confirm"
      })
        .then((result) => {
          if (result.value) {
            this.onStartTime(true)
          }
        });
    },
    onStartTime(confrim) {
      this.loading = true
      this.$store
        .dispatch('restaurantSale/counterCheckout/serviceDurationDetail', {
          stock_out_id: this.item.stock_out_id,
          product_id: this.item.product_id,
          ref_table_id: this.item.ref_table_id,
          start_time: this.item.start_time,
          end_time: this.item.end_time,
          service_length: this.item.service_length,
          is_pre_charge: this.item.is_pre_charge,
          action_type: 'start-time',
          confrim: confrim
        })
        .then((response) => {
          this.onHideService()
          if (response.table_id) {
            this.$notification['warning']({
              message: 'SERVICE DURATION',
              description: response.message,
              placement: 'bottomRight'
            })
            this.onConfrim(response)
          } else {
            this.$notification['success']({
              message: 'SERVICE DURATION',
              description: response.message,
              placement: 'bottomRight'
            })
          }
        })
        .catch(error => {
          this.$notification['error']({
            message: 'SERVICE DURATION',
            description: error.message,
            placement: 'bottomRight'
          })
        })
        .finally(() => {
          this.fetchTables()
          this.loading = false
        })
    },
    onEndTime() {
      this.loading = true
      this.$store
        .dispatch('restaurantSale/counterCheckout/serviceDurationDetail', {
          stock_out_id: this.item.stock_out_id,
          product_id: this.item.product_id,
          ref_table_id: this.item.ref_table_id,
          start_time: this.item.start_time,
          end_time: this.item.end_time,
          service_length: this.item.service_length,
          is_pre_charge: this.item.is_pre_charge,
          action_type: 'end-time'
        })
        .then((response) => {
          this.$notification['success']({
            message: 'SERVICE DURATION',
            description: response.message,
            placement: 'bottomRight'
          })
          this.onHideService()
          if (response.table_id) {
            Swal.fire({
              icon: 'info',
              html: response.message +
                '<br /><b>' +
                (response.next_locker_message ? response.next_locker_message : '') + '</b>'
            })
          }
        })
        .catch(error => {
          this.$notification['error']({
            message: 'SERVICE DURATION',
            description: error.message,
            placement: 'bottomRight'
          })
        })
        .finally(() => {
          this.fetchTables()
          this.loading = false
        })
    },
    badgeClass(item) {
      const end_time = moment(item.start_time).add(item.service_length, "minutes");
      if (item.start_time && item.end_time) {
        return 'bg-secondary'
      }
      if (!item.start_time) {
        return 'bg-success'
      }

      if (item.start_time && moment().isAfter(end_time)) {
        return 'bg-warning'
      }
      return 'bg-primary'

    },
    startTime(item) {
      return item.start_time ? moment(item.start_time).format("hh:mm A") : 'N/A'
    },
    endTime(item) {
      if (item.end_time) {
        return item.end_time ? moment(item.end_time).format("hh:mm A") : 'N/A'
      } else {
        return item.start_time ? moment(item.start_time).add(item.service_length, "minutes").format("hh:mm A") : 'N/A'
      }
    },
    cookingStatusClass(cooking_status_id) {
      if (cooking_status_id == 1) {
        return 'text-info'
      }
      if (cooking_status_id == 2) {
        return 'text-primary'
      }
      if (cooking_status_id == 3) {
        return 'text-success'
      }
      return 'text-danger'
    },
    productPhoto(item) {
      if (item.photo === null) return ''
      return `/api/files?filePath=${item.photo}`
    }
  }
}
</script>
<style scoped>
.pos-counter {
  padding: 0 0px;
}

.badge {
  font-size: 10px;
  line-height: 1.1;
  cursor: pointer;
}

.card-info {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 5px;
  background: #f2f3f4;
  padding: 5px 15px 10px 15px;
  border-radius: 0 0 4px 4px;
  border: none;
}

.info-item {
  display: flex;
  flex-direction: column;
}

.info-label {
  font-size: 0.65rem;
  color: #666;
  margin-bottom: 0px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  white-space: nowrap;
}

.info-value {
  font-size: 0.85rem;
  color: #333;
  font-weight: 500;
  white-space: nowrap;
}
</style>